module.exports = __webpack_public_path__ + "img/Shiba-BG1.14671359.jpg";